(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('WarrantyStatus', WarrantyStatus);

  WarrantyStatus.$inject = ['$resource', 'API_URI'];

  function WarrantyStatus($resource, API_URI) {
    var resourceUrl = API_URI + 'api/merchant-dashboard/warrantyStatus/';

    return $resource(resourceUrl, {}, {
      'getWarrantyStatusTotal': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'getWarrantyStatusCustomer': {
        method: 'GET',
        url: API_URI + '/api/merchant-dashboard/customerWarrantyStatus/:customer_id',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
